module.exports = __webpack_public_path__ + "img/cake-21.82e643d0.svg";